module.exports = __webpack_public_path__ + "static/media/certificado.1e38372b.png";